// Screen 6 (spec 13 §Screens): `/c/{slug}/kpis/entry/hours` (KPIs › data entry: managers
// and operators). The week is the focused period (`p`), else the company's current week in its
// own calendar (S1-17 review #7); time entries are `core`, so no add-on gate.
import { createRoute } from "@tanstack/react-router";
import { companyPeriodNow } from "../features/entry/calendar";
import { HoursForm } from "../features/entry/hours-form";
import { useCompany } from "../features/use-feature";
import { useFocus } from "../focus/focus";
import { DataEntryGate } from "../shell/mode-gate";
import { kpisRoute } from "./c.$slug.kpis";

export const hoursEntryRoute = createRoute({
  getParentRoute: () => kpisRoute,
  path: "entry/hours",
  component: function HoursEntry() {
    const { api } = hoursEntryRoute.useRouteContext();
    const company = useCompany();
    const { focus } = useFocus();
    const week = focus.period ?? companyPeriodNow(company.calendar, "week");
    return (
      <DataEntryGate what="Hours entry">
        <HoursForm api={api} company={company} week={week} />
      </DataEntryGate>
    );
  },
});
